var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 14C23 18.4183 19.4183 22 15 22V21V14H22H23ZM16 15H21.9291C21.4906 18.0657 19.0657 20.4906 16 20.9291V15Z",
    fill: "#304A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C15.4183 2 19 5.58172 19 10H11V18C6.58172 18 3 14.4183 3 10C3 5.58172 6.58172 2 11 2ZM17.9291 9C17.4439 5.60771 14.5265 3 11 3C9.28648 3 7.71677 3.61568 6.5 4.63789C4.97153 5.92196 4 7.84752 4 10C4 13.5265 6.60771 16.4439 10 16.9291V9H17.9291Z",
    fill: "#304A5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13003 14.6637L10.13 9.16366L10.87 9.83634L5.86997 15.3363L5.13003 14.6637Z",
    fill: "#304A5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37165 4.16552L10.8716 9.16552L10.1284 9.83448L5.62835 4.83448L6.37165 4.16552Z",
    fill: "#304A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStocks);
export default __webpack_public_path__ + "static/media/ico-stocks.30978c84c22dcaec2c4d8402221dd413.svg";
export { ForwardRef as ReactComponent };